module.exports = __webpack_public_path__ + "static/media/filter-icon.99d947c6.svg";